export default __webpack_public_path__ + "static/media/product-2.81f6b2cd.jpg";